<ape-drawer
  [visible]="visible"
  [title]="title"
  [position]="'right'"
  [closable]="true"
  [dismissible]="false"
  (closeClick)="onCancelClick()"
>
  <div class="flex flex-col gap-5 border-b-[1px] border-b-[var(--colors-gray-scale-gray-4)] pb-[20px]">

    <div class="w-full h-[1px] bg-[#EEEEEE]"></div>
    <div class="flex flex-row justify-between items-center w-full">
      <p class="text-[#000] text-[16px] font-normal leading-[24px]">
        <b>{{activeFiltersCount}}</b>
        {{ activeFiltersCount === 1
            ? (TRANSLATION_KEYS.admin.goalSettingMonitoring.ACTIVE_FILTER | translate)
            : (TRANSLATION_KEYS.admin.goalSettingMonitoring.ACTIVE_FILTERS | translate) }}
      </p>
      <p
        role="button"
        tabindex="0"
        class="text-[#0048D9] text-[16px] font-semibold leading-[16px] underline cursor-pointer"
        (click)="onResetClick()"
      >{{ TRANSLATION_KEYS.admin.goalSettingMonitoring.RESET_FILTERS | translate }}</p>
    </div>
    <div class="w-full h-[1px] bg-[#EEEEEE]"></div>

    <ape-multi-select
      *ngIf="cardStatusOptions.length > 0"
      [id]="'gs-card-status-filter'"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.CARD_STATUS | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SELECT_PLACEHOLDER | translate"
      [options]="cardStatusOptions"
      [selectedOptions]="selectedCardStatuses"
      (selectedOptionsChange)="onCardStatusesChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <ape-multi-select
      *ngIf="proposalStatusOptions.length > 0"
      [id]="'gs-proposal-status-filter'"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.PROPOSAL_STATUS | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SELECT_PLACEHOLDER | translate"
      [options]="proposalStatusOptions"
      [selectedOptions]="selectedProposalStatuses"
      (selectedOptionsChange)="onProposalStatusesChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <ape-multi-select
      *ngIf="updatesOptions.length > 0"
      [id]="'gs-updates-filter'"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.UPDATES | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SELECT_PLACEHOLDER | translate"
      [options]="updatesOptions"
      [selectedOptions]="selectedUpdates"
      (selectedOptionsChange)="onUpdatesChange($event)"
      [optionLabel]="'label'"
      [filter]="false"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <ape-multi-select
      *ngIf="scorecardTypeOptions.length > 0"
      [id]="'gs-scorecard-type-filter'"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SCORECARD_TYPE | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SELECT_PLACEHOLDER | translate"
      [options]="scorecardTypeOptions"
      [selectedOptions]="selectedScorecardTypes"
      (selectedOptionsChange)="onScorecardTypesChange($event)"
      [optionLabel]="'label'"
      [filter]="false"
      [variant]="'outlined'"
      [size]="'medium'"
    />

    <ape-multi-select
      *ngIf="managerOptions.length > 0"
      [id]="'gs-manager-filter'"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.MANAGER | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SELECT_PLACEHOLDER | translate"
      [options]="managerOptions"
      [selectedOptions]="selectedManagers"
      (selectedOptionsChange)="onManagersChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    >
      <ng-template #optionTemplate let-option>
        <div class="flex flex-col justify-start items-start gap-1">
          <span class="text-base font-normal text-[#334155]">{{option.forename}} {{option.surname}}</span>
          <span *ngIf="option.email" class="text-sm font-normal text-[#334155]">{{option.email}}</span>
        </div>
      </ng-template>
    </ape-multi-select>

    <ape-multi-select
      *ngIf="departmentOptions.length > 0"
      [id]="'gs-department-filter'"
      [label]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.DEPARTMENT | translate"
      [showLabel]="true"
      [placeholder]="TRANSLATION_KEYS.admin.goalSettingMonitoring.filter.SELECT_PLACEHOLDER | translate"
      [options]="departmentOptions"
      [selectedOptions]="selectedDepartments"
      (selectedOptionsChange)="onDepartmentsChange($event)"
      [optionLabel]="'label'"
      [filter]="true"
      [variant]="'outlined'"
      [size]="'medium'"
    />

  </div>

  <div class="flex flex-col justify-between items-center sm:flex-row sm:gap-0 gap-2 mt-4">
    <ape-button
      [minWidth]="'182px'"
      [label]="cancelLabel | translate"
      [variant]="'primary'"
      [aspect]="'outline'"
      [size]="'large'"
      (buttonClick)="onCancelClick()"
    />
    <ape-button
      [minWidth]="'182px'"
      [label]="confirmLabel | translate"
      [variant]="'primary'"
      [aspect]="'fill'"
      [size]="'large'"
      (buttonClick)="onConfirmClick()"
    />
  </div>
</ape-drawer>
